export default {
    data() {
        return {
            inventoryKey: '',
            type: '',
            dot: '',
            operand: '',
            adjustAmount: '',
            averageCost: '',
            supplier: null,
            isCountAverage: '',
            updateAt: ''
        };
    }
}